import { useSelector } from 'react-redux';
import { selectIsHealer, selectIsMobileUser, selectIsNavbarVisible } from '../../../../store/selectors/global.selector';
import ClientDesktopNavbar from './desktop/ClientDesktopNavbar';
import ClientMobileNavbar from './mobile/ClientMobileNavbar';
import HealerNavbar from './desktop/HealerDesktopNavbar';

const NavbarContainer = () => {
  const isMobileUser = useSelector(selectIsMobileUser);
  const isHealer = useSelector(selectIsHealer);
  const showNavbar = useSelector(selectIsNavbarVisible);

  if (!showNavbar) {
    return null;
  }

  if (!isHealer) {
    if (isMobileUser) {
      return <ClientMobileNavbar />;
    } else {
      return <ClientDesktopNavbar />;
    }
  } else {
    return <HealerNavbar />;
  }
};
export default NavbarContainer;
